import React, {Component} from 'react';
import {connect} from 'react-redux'
import SplitFormStripe from "./Include/SplitFormStripe";
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

class AddCardSection extends Component {
    render() {
        return (
            <div>
                <Elements stripe={stripePromise} options={{locale : 'en' }}>
                    <SplitFormStripe isRedirect/>
                </Elements>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user:state.auth.user
    }
}
export default connect(mapStateToProps, {})(AddCardSection)






// WEBPACK FOOTER //
// ./src/components/Settings/Dashboard/AddCardSection.js